export default __webpack_public_path__ + "static/media/investmenticontwo.4977e916.svg";